import flag_icon from '../../../../../assets/icons/flag_icon.svg';
import english from '../../../../../assets/flags/english.png';
import chinese from '../../../../../assets/flags/chinese.png';
import spanish from '../../../../../assets/flags/spanish.png';
import french from '../../../../../assets/flags/french.png';
import hindi from '../../../../../assets/flags/hindi.png';
import german from '../../../../../assets/flags/german.png';
import dutch from '../../../../../assets/flags/dutch.png';
import arabic from '../../../../../assets/flags/arabic.png';
import japanese from '../../../../../assets/flags/japanese.png';
import russian from '../../../../../assets/flags/russian.png';
import korean from '../../../../../assets/flags/korean.png';
import portuguese from '../../../../../assets/flags/portuguese.png';
import italian from '../../../../../assets/flags/italian.png';
import romanian from '../../../../../assets/flags/romanian.png';
import swahili from '../../../../../assets/flags/swahili.png';
import thai from '../../../../../assets/flags/thai.png';
import indonesia from '../../../../../assets/flags/indonesia.png';
import turkish from '../../../../../assets/flags/turkish.png';
import vietnamese from '../../../../../assets/flags/vietnamese.png';
import polish from '../../../../../assets/flags/polish.png';
import bengali from '../../../../../assets/flags/bengali.png';
import tamil from '../../../../../assets/flags/tamil.png';
import telugu from '../../../../../assets/flags/telugu.png';
import esperanto from '../../../../../assets/flags/esperanto.png';

import morning from '../../../../../assets/icons/morning.png';
import afternoon from '../../../../../assets/icons/afternoon.png';
import evening from '../../../../../assets/icons/evening.png';
import night from '../../../../../assets/icons/night.png';

// Language Options
export const langOptions = [
    { value: 'All', flag: flag_icon },
    { value: 'English', flag: english },
    { value: 'Chinese', flag: chinese },
    { value: 'Spanish', flag: spanish },
    { value: 'French', flag: french },
    { value: 'Hindi', flag: hindi },
    { value: 'German', flag: german },
    { value: 'Dutch', flag: dutch },
    { value: 'Arabic', flag: arabic },
    { value: 'Japanese', flag: japanese },
    { value: 'Russian', flag: russian },
    { value: 'Korean', flag: korean },
    { value: 'Portuguese', flag: portuguese },
    { value: 'Italian', flag: italian },
    { value: 'Romanian', flag: romanian },
    { value: 'Swahili', flag: swahili },
    { value: 'Thai', flag: thai },
    { value: 'Indonesian', flag: indonesia },
    { value: 'Turkish', flag: turkish },
    { value: 'Vietnamese', flag: vietnamese },
    { value: 'Polish', flag: polish },
    { value: 'Bengali', flag: bengali },
    { value: 'Tamil', flag: tamil },
    { value: 'Telugu', flag: telugu },
    { value: 'Esparanto', flag: esperanto },
];

// Course Options
export const courseOptions = ['All', 'Academics', 'Test Preparation', 'Spoken Languages'];

// Availability Options
export const timeOptions = [
    { label: 'Morning', time: '8am - 11am', img: morning },
    { label: 'Afternoon', time: '12pm - 3pm', img: afternoon },
    { label: 'Evening', time: '4pm - 7pm', img: evening },
    { label: 'Night', time: '8pm - 11pm', img: night }
];

// Day Options
export const dayOptions = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
